!function(){
  'use strict';
  function mainImg(card){
    var g=card.querySelector('.card-gallery');
    if(!g)return null;
    return g.querySelector('slideshow-slide[aria-hidden="false"] img')||g.querySelector('.product-media__image')||g.querySelector('img');
  }
  function swap(thumb){
    var src=thumb.getAttribute('data-berry-img');
    if(!src)return;
    var card=thumb.closest('product-card,.product-card');
    if(!card)return;
    var img=mainImg(card);
    if(!img)return;
    if(!img.__berryOrig){img.__berryOrig={src:img.getAttribute('src'),set:img.getAttribute('srcset'),sizes:img.getAttribute('sizes')};}
    img.setAttribute('srcset','');
    img.removeAttribute('sizes');
    img.setAttribute('src',src);
  }
  function restore(card){
    var img=mainImg(card);
    if(!img||!img.__berryOrig)return;
    var o=img.__berryOrig;
    if(o.set!=null)img.setAttribute('srcset',o.set);
    if(o.sizes!=null)img.setAttribute('sizes',o.sizes);
    if(o.src!=null)img.setAttribute('src',o.src);
  }
  document.addEventListener('pointerover',function(e){
    var t=e.target.closest?e.target.closest('.berry-card-variants__item'):null;
    if(t)swap(t);
  },{passive:true});
  document.addEventListener('pointerout',function(e){
    var wrap=e.target.closest?e.target.closest('.berry-card-variants'):null;
    if(!wrap)return;
    if(e.relatedTarget&&wrap.contains(e.relatedTarget))return;
    var card=wrap.closest('product-card,.product-card');
    if(card)restore(card);
  },{passive:true});
}();
